import genererModeReglement from '@/services/general/genererModeReglement';
import genererDelaiReglement from '@/services/parametrage/generation/genererDelaiReglement';
import genererDelaiReglementDetail from '@/services/parametrage/generation/genererDelaiReglementDetail';
import * as devisConf from '@/configuration/devisConf';

export default function genererDevisCommande(type, sousType, societe, sens, module) {
  const modeReglement = genererModeReglement();
  const delaiReglement = genererDelaiReglement();
  const delaiReglementDetail = genererDelaiReglementDetail();
  let textSignature = null;
  switch (type) {
    case devisConf.TYPE_COMMANDE:
      textSignature = societe.texteEditionCommandeSignature;
      break;
    case devisConf.TYPE_DEVIS:
      textSignature = societe.texteEditionDevisSignature;
      break;
    default: textSignature = null;
  }
  return {
    type: type,
    echeanciers: [],
    sousType: sousType,
    dateDevisCommande: new Date(),
    dateValidite: null,
    commercialId: null,
    assistantId: null,
    theme: null,
    role: null,
    id: null,
    commentaireInterne: null,
    commentaire: null,
    intervenants: [],
    lignesCommande: [],
    commissions: [],
    penalite: true,
    escompte: true,
    recouvrement: true,
    montantHt: 0,
    montantTva: 0,
    montantTtc: 0,
    companyId: 1,
    factureGroupee: true,
    repartitionsTva: [],
    echeancierPaiement: [],
    modeReglementId: null,
    modeReglement: modeReglement,
    delaiReglementId: null,
    delaiReglement: delaiReglement,
    delaiReglementDetail: delaiReglementDetail,
    categorieVente: null,
    renouvelable: false,
    reconductible: false,
    dateRenouvellement: null,
    datePreavis: null,
    adresseLivraison: societe ? societe.adresseLivraison : null,
    masqueRemise: false,
    sens: sens,
    gestionEcheancier: false,
    estSigne: false,
    texteEditionSignature: textSignature,
    planMediaId: null,
    regleFacturationId: null,
    tiersFactorId: null,
    factorTransmis: false,
    factorDateTransmission: null,
    etatSuivis: [],
    transmissionAuClub: false,
    dateTransmissionAuClub: null,
    transmissionAuClient: false,
    dateTransmissionAuClient: null,
    nePasRelancer: false,
    societeId: societe?.id,
    campagneId: null,
    campagne: null,
    tags: [],
    // for indexation
    estIndexable: false,
    valeurIndexationReference: null,
    dateIndexationReference: null,
    valeurIndexationActuel: null,
    dateIndexationActuel: null,
    dateDerniereIndexation: null,
    textPenalite: societe.retardPaiement,
    module,
  };
}
